function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledSecondaryLinkItemComponent } from "./secondary-link-item-component.scss";
import classNames from "classnames";
import { SECONDARY_HEADER_LINK_CLICKED } from "/constants/bigbrain-event-types";
import { withGenericConfig } from "contexts/generic-config-context";
class SecondaryLinkItemComponent extends PureComponent {
    render() {
        const { title, url, isSelected, translate } = this.props;
        return /*#__PURE__*/ _jsx(StyledSecondaryLinkItemComponent, {
            href: url,
            className: classNames("secondary-link-item-component", {
                selected: isSelected
            }),
            onClick: this.onClick,
            children: translate(title)
        });
    }
    constructor(...args){
        super(...args);
        _define_property(this, "onClick", (e)=>{
            const { url } = this.props;
            const isKeyboardEvent = (e === null || e === void 0 ? void 0 : e.screenX) === 0 && (e === null || e === void 0 ? void 0 : e.screenY) === 0;
            BigBrain("track", SECONDARY_HEADER_LINK_CLICKED, {
                kind: url,
                info1: isKeyboardEvent ? "keyboard" : "mouse"
            });
        });
    }
}
export default withGenericConfig(SecondaryLinkItemComponent);
